import React, { useState, useEffect } from "react";
import FetchContent from "../dynamic/fetchContent";
import useAuth from "../../hooks/useAuth";
import { useTranslation } from "react-i18next";
import Content from "../dynamic/Content";
import axios from "../../api/axios";

const WEBSITE_URL = "/website";

export default function EnLegalConditions() {
  const { username, auth } = useAuth();
  const { t, i18n } = useTranslation();
  const art = i18n.language;

  const [sections, setSections] = useState([]);

  // Fetch the list of terms sections on load
  useEffect(() => {
    const fetchSections = async () => {
      try {
        const response = await axios.get(WEBSITE_URL, {
          params: {
            username,
            art,
            title: "terms-sections"
          }
        });

        const stored = JSON.parse(response.data.entry.content);
        if (Array.isArray(stored)) {
          const formatted = [];
          for (let i = 0; i < stored.length; i += 2) {
            formatted.push({ heading: stored[i], paragraph: stored[i + 1] });
          }
          setSections(formatted);
        }
      } catch (err) {
        console.error("Failed to load terms sections", err);
        // Default fallback if no backend entry exists
        setSections([
          { heading: "terms-h1", paragraph: "terms-p1" },
          { heading: "terms-h2", paragraph: "terms-p2" }
        ]);
      }
    };

    fetchSections();
  }, [username, art]);

  // Save the updated section list to backend
  const saveSectionList = async (updatedSections) => {
    const content = JSON.stringify(
      updatedSections.flatMap((s) => [s.heading, s.paragraph])
    );

    try {
      await axios.put(WEBSITE_URL, {
        username,
        art,
        title: "terms-sections",
        content
      });
    } catch (err) {
      console.error("Failed to save terms section list", err);
    }
  };

  const handleAddSection = async () => {
    const newIndex = sections.length + 1;
    const newHeading = `terms-h${newIndex}`;
    const newParagraph = `terms-p${newIndex}`;

    const updated = [...sections, { heading: newHeading, paragraph: newParagraph }];
    setSections(updated);
    await saveSectionList(updated); // Save immediately
  };

  return (
    <div className="default terms-page">
      <div className="terms-title">
        <h1>{t("dashboard_page.TC.title")}</h1>
      </div>

      {sections.map((section, index) => (
        <div key={index} className="terms-section container">
          <div className="terms-section-content">
            <h2>
              {!auth?.role ? (
                <FetchContent title={section.heading} />
              ) : (
                <Content title={section.heading} styling="p" />
              )}
            </h2>
            <div className="terms-paragraph">
              {!auth?.role ? (
                <FetchContent title={section.paragraph} />
              ) : (
                <Content title={section.paragraph} styling="p" />
              )}
            </div>
          </div>
        </div>
      ))}

      {auth?.role && (
        <div style={{ textAlign: "center", marginTop: "30px" }}>
          <button
            type="button"
            onClick={handleAddSection}
            style={{
              padding: "10px 20px",
              fontSize: "16px",
              backgroundColor: "#003d51",
              color: "white",
              borderRadius: "5px",
              border: "none",
              cursor: "pointer"
            }}
          >
            + {t("button.add_section") || "Add Section"}
          </button>
        </div>
      )}
    </div>
  );
}
